import * as actionTypes from './actionTypes';

export const initialCreateProfileState = {
  updatePersonalInfoResponse: {},
  isUpdatePersonalInfoSuccess: false,
  hasCalledUpdatePersonalInfo: false,
  isFormDirtyAfterCall: false,
  billingFormData: {},
  creditCheckSuccess: false,
  creditCheckError: null,
  showUSPSAddressValidationAlert: false,
  hasAcceptedUSPSOverride: false,
};

function createProfileReducer(state = initialCreateProfileState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_PERSONAL_INFO:
      return {
        ...state,
        isFormDirtyAfterCall: false,
      };
    case actionTypes.UPDATE_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        updatePersonalInfoResponse: action.response,
        isUpdatePersonalInfoSuccess: true,
        hasCalledUpdatePersonalInfo: true,
      };
    case actionTypes.UPDATE_PERSONAL_INFO_FAILURE:
      return {
        ...state,
        updatePersonalInfoResponse: action.response || {},
        isUpdatePersonalInfoSuccess: false,
        hasCalledUpdatePersonalInfo: true,
      };
    case actionTypes.SET_PERSONAL_INFO_FORM_DIRTY:
      return {
        ...state,
        isFormDirtyAfterCall: true,
      };
    case actionTypes.CREATE_PROFILE_SAVE_BILLING_ADDRESS:
      return {
        ...state,
        billingFormData: action.data,
      };
    case actionTypes.SUBMIT_CREATE_PROFILE_SUCCESS:
      return {
        ...state,
        creditCheckSuccess: true,
        creditCheckError: null,
      };
    case actionTypes.SUBMIT_CREATE_PROFILE_FAILURE:
      return {
        ...state,
        creditCheckSuccess: false,
        creditCheckError: action.error || 'Unknown error',
      };
    case 'USPS_ADDRESS_VALIDATION_ERROR':
      return {
        ...state,
        showUSPSAddressValidationAlert: action.response,
      };
    case actionTypes.SET_USPS_ADDRESS_OVERRIDE_ACCEPTED:
      return {
        ...state,
        hasAcceptedUSPSOverride: true,
      };
    case 'RESET_CREATE_PROFILE':
      return { ...initialCreateProfileState };
    default:
      return state;
  }
}

export default createProfileReducer;
